import React, { useEffect, useState, } from "react";
import { data } from '../../data/setups';
import { useSetup } from '../../context/SetupContext'
import PrimaryButton from '../buttons/PrimaryButton';
import SecondaryButton from '../buttons/SecondaryButton';
import DeleteButton from '../buttons/DeleteButton';
import './SetupManagement.css';

const SetupManagement = ({ handleLoadExcel, onClick }) => {
    const { exportSetup, handleFileSelect, deleteAllLabels } = useSetup();
    const [selectedGroup, setSelectedGroup] = useState("Product Focus");
    const [selectedSetup, setSelectedSetup] = useState(data["Product Focus"][0]);
    const [activeTab, setActiveTab] = useState('labelTypes');
    const [setups, setSetups] = useState([]);
  

  useEffect(() => {
    if (selectedGroup) setSetups(data[selectedGroup] || []);
  }, [selectedGroup]);

  const handleGroupClick = (group) => {
    setSelectedGroup(group)
    setSelectedSetup({});
    setActiveTab('labelTypes');
  };

  const handleSetupClick = (setup) => {
    setSelectedSetup(setup);
    setActiveTab('labelTypes');
  };

  return (
    <div className="setup-management-container">
        <div className="default-setups-container">
            <div className="default-setups-header">
                <p>
                    <strong className="title">Default Setups</strong> are designed to cover standard <strong>Factory study formats</strong>. Select the study format you’ll work on and the setup that matches your analysis. Example: if you’re running a <strong>Product Focus</strong> on a skincare product, choose <strong>Skincare Product Focus</strong> set-up. You can then start collecting and labeling your verbatims right away.<br /><br />
                    For <strong>Celebrity Snap</strong>, <strong>BSA</strong>, or <strong>Brand Snap</strong>, there is only one available setup—no additional selection needed.<br /><br />
                    For all other study formats (notably larger Agency ones), follow the current process: your <strong>PL</strong> will send you the setup, then load it via “<strong>Load Excel set-up</strong>”.
                </p>
            </div>
            <div className="default-setups-body">
                <div className="default-setup-groups-container">
                    <h4>Formats</h4>
                    <ul className="setup-groups-list">
                        {Object.keys(data).map((group, index) => (
                            <li key={index} className="item" onClick={() => handleGroupClick(group)} style={{ 
                                backgroundColor: group === selectedGroup ? '#5034C6' : 'transparent',
                                color: group === selectedGroup ? 'white' : 'black'
                            }}>
                                {group}
                            </li>
                        ))}
                    </ul>
                </div>
                <div className="setups-items-container">
                    <h4>Setups</h4>
                    <ul className="setups-list">
                        {setups.map((setup) => (
                            <li key={setup.id} className="item" onClick={() => handleSetupClick(setup)} style={{ 
                                backgroundColor: setup.label === selectedSetup.label ? '#5034C6' : 'transparent',
                                color: setup.label === selectedSetup.label ? 'white' : 'black'
                            }}>
                                {setup.label}
                            </li>
                        ))}
                    </ul>
                </div>
                {selectedSetup && Object.keys(selectedSetup).length > 0 && (
                    <div className="setup-details-container">
                        <h4>Setup Preview</h4>
                        <div className="tabs-header">
                            <button
                                className={`tab-button ${activeTab === 'labelTypes' ? 'active' : ''}`}
                                onClick={() => setActiveTab('labelTypes')}
                            >
                                Label Types
                            </button>
                            <button
                                className={`tab-button ${activeTab === 'labels' ? 'active' : ''}`}
                                onClick={() => setActiveTab('labels')}
                            >
                                Labels
                            </button>
                            <button
                                className="tab-button"
                                onClick={() => onClick(selectedSetup?.data?.labelTypes, selectedSetup?.data?.labels)}
                            >
                                Use this Setup
                            </button>
                        </div>
                        {activeTab === 'labelTypes' && (
                            <div className="table-container" style={{ height: '42vh'}}>
                                <table id="label-types-table">
                                <thead>
                                    <tr>
                                        {["Type", "Number of Labels", "Mandatory", "Sentiment-enabled", "Multi-value"].map((header, index) => (
                                            <th key={index} className="setup-table-headers">{header}</th>
                                        ))}
                                    </tr>
                                </thead>
                                <tbody>
                                    {Object.keys(selectedSetup.data.labelTypes).length > 0 && (
                                        Object.entries(selectedSetup.data.labelTypes).map(([type, data]) => {
                                            const labelCount = selectedSetup.data.labels[type]?.length || 0;
                                            return (
                                                <tr key={type}>
                                                    <td className="strong-text">{type}</td>
                                                    <td>{labelCount}</td>
                                                    <td>{data?.mandatory ? data.mandatory.toString() : 'false'}</td>
                                                    <td>{data?.sentimentEnabled ? data.sentimentEnabled.toString() : 'false'}</td>
                                                    <td>{data?.multiValue ? data.multiValue.toString() : 'false'}</td>
                                                </tr>
                                            );
                                        })
                                    )}
                                </tbody>
                                </table>
                            </div>
                        )}
                        {activeTab === 'labels' && (
                            <div className="table-container" style={{ height: '42vh'}}>
                                <table id="label-keyword-table">
                                    <thead>
                                        <tr>
                                            {["Label", "Type", "Keywords", "Explanation"].map((header, index) => (
                                                <th key={index} className="setup-table-headers">{header}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {Object.keys(selectedSetup.data.labels).length > 0 && (
                                            Object.entries(selectedSetup.data.labels || {})
                                                .flatMap(([labelType, labelArray]) =>
                                                    Array.isArray(labelArray) ? labelArray.map((labelObj) => ({ labelType, ...labelObj })) : []
                                                )
                                                .map(({ labelType, name, keywords, explanation }, index) => {
                                                    return (
                                                        <tr key={index}>
                                                            <td className="strong-text">{name}</td>
                                                            <td>{labelType ? labelType : ''}</td>
                                                            <td>{Array.isArray(keywords) ? keywords.join('; ') : ''}</td>
                                                            <td>{explanation ? explanation : ''}</td>
                                                        </tr>
                                                    );
                                                })
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
        <div className="setup-options-container">
            <PrimaryButton onClick={handleLoadExcel}>
                <i className="fa-solid fa-upload"></i> Load Excel Setup
            </PrimaryButton>
            <SecondaryButton onClick={exportSetup}>
                <i className="fa-solid fa-download"></i> Export Setup to XLSX
            </SecondaryButton>
            <input
                type="file"
                id="setup-xlsx-file-input"
                accept=".xlsx"
                style={{ display: 'none' }}
                onChange={handleFileSelect}
            />
            <DeleteButton onClick={deleteAllLabels}>
                <i className="fa-solid fa-trash"></i> Delete All Labels
            </DeleteButton>
        </div>
    </div>
  );
}

export default SetupManagement;